import { observer } from 'mobx-react-lite'

import { EntityHeader, HeaderChip } from '@/Ship/Components/EntityCard'
import { formatPhone } from '@/Ship/Helpers/formatPhone'

import type { CarrierFormContextLike } from '../Contracts/ICarrier'

const firstString = (value: unknown): string | null =>
    Array.isArray(value) && typeof value[0] === 'string' && value[0] !== '' ? value[0] : null

/**
 * Шапка перевізника (`SPEC-010` §9.3) — окремим observer-компонентом: вона
 * читає назву, статус і контакти, які редагують, а ядровий `FormField` на
 * кожне перемальовування шаблону перемонтовує всі поля форми (`SPEC-002` §4.2).
 *
 * Ліворуч — назва й статус бейджем кольору довідника. Праворуч — перший
 * телефон і перша пошта: клік копіює, без іконки (правило дизайну карток CRM).
 * Решта телефонів і пошт — у блоці «Головне» з кнопкою копіювання. Зірочку
 * «в обране» ставить Ship (`FAVORITE_RESOURCES`).
 */
export const CarrierCardHeader = observer(({ formContext }: { formContext: CarrierFormContextLike }) => {
    const values = formContext.values ?? {}
    const status = values.status
    const phone = firstString(values.phones)
    const email = firstString(values.emails)
    const title = typeof values.title === 'string' ? values.title : ''

    const contacts =
        phone || email ? (
            <>
                {phone ? <HeaderChip copyText={formatPhone(phone)}>{formatPhone(phone)}</HeaderChip> : null}
                {email ? <HeaderChip copyText={email}>{email}</HeaderChip> : null}
            </>
        ) : undefined

    return (
        <EntityHeader
            status={
                status && typeof status.title === 'string'
                    ? { label: status.title, ...(status.color ? { color: status.color } : {}) }
                    : undefined
            }
            aside={contacts}
            {...(title !== '' ? { title } : {})}
        />
    )
})
